import React, { useState, useEffect, useContext } from "react";
import EmpresaContext, { EnviarContato } from "../../context";
import { Corretor, Cliente, Reserva } from "smart-imob-types";
import Spinner from "react-spinner-material";
import get from "../../client_api";
import DatePicker from "../global-components/date-picker";
import { addDays } from "date-fns";
import { hospedes as hospedesData } from "../../utils/util_data";
import { AsideSelectForm } from "./AsideFormSelect";
import InputMask from "react-input-mask";

type AgenciadorInfoProps = {
  agenciador_id: string | null;
  codigo: string;
  db_id: string;
  temporada: boolean;
  uid: string | null;
  firstInputRef?;
};

function PropertyForm(props: AgenciadorInfoProps) {
  const [Agenciador, setAgenciador] = useState<Corretor | null>(null);
  const [Afiliado, setAfiliado] = useState<string | null>(null);
  const [reservas, setReservas] = useState<Reserva[] | null>([]);
  const [Loading, setLoading] = useState(true);
  const empresa = useContext(EmpresaContext);

  const [nome, setnome] = useState("");
  const [email, setemail] = useState("");
  const [telefone, settelefone] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [hospedes, setHospedes] = useState({
    value: 1,
    label: "1 hospede"
  });
  const [reservedDates, setReservedDates] = useState([new Date()]);
  const [vericando, setVerificando] = useState(false);

  const blockDates = array => {
    function getDates(startDate, stopDate) {
      var dateArray = new Array();
      var currentDate = startDate;
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate));
        currentDate = addDays(currentDate, 1);
      }
      return dateArray;
    }
    const reserve_dates = array.map(reserva => {
      const startDate = new Date(reserva.data_inicio);
      const endDate = new Date(reserva.data_fim);
      return getDates(startDate, endDate);
    });
    return reserve_dates.flat();
  };

  useEffect(() => {
    let param = new URLSearchParams(window.location.search);
    let idAfiliado = param.get("afiliado") || null;
    setAfiliado(idAfiliado);
    // console.log(idAfiliado)
    /**
     * Pegar informações das reservas.
     * @return {Reserva}      Reservas do banco.
     */
    const getReservas = async () => {
      try {
        const reserva_data: Reserva[] = await get(
          window.location.origin,
          `reservas/${props.db_id}`
        ).then(result => {
          const reserves_array: Reserva[] = result;
          // console.log('array com as reservas: ', reserves_array)
          setReservedDates(blockDates(reserves_array));
          return reserves_array;
        });
        setReservas(reserva_data);
      } catch (error) {
        console.log("erro ao pegar reservas", error);
      }
    };

    if (props.agenciador_id) {
    } else setLoading(false);
    if (props.temporada) {
      getReservas();
    }
  }, []);
  let center = {
    display: "flex",
    marginTop: "10px"
    // justifyContent: "center",
    // alignItems: "center"
  };
  let containSpinner = {
    ...center,
    paddingTop: 40,
    paddingBottom: 10
  };

  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function updateDate(dates) {
    try {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
    } catch (error) {
      console.log("error");
    }
  }
  async function onConfirm() {
    try {
      setVerificando(true);
      //https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
      if (!validateEmail(email)) {
        setVerificando(false);
        return alert("O email enviado é inválido!");
      }
      if (!telefone.match(/^\([0-9]{2}(?:\))\s?[0-9]{5}(?:-)[0-9]{4}$/)) {
        setLoading(false);
        return alert("Insira um telefone válido!");
      }
      let cliente: Cliente = {
        foto: null,
        nome,
        created_at: new Date(),
        edited_at: new Date(),
        email,
        DDD: telefone.slice(1, 3),
        telefone: telefone.slice(5),
        CPF: null,
        FGTS: null,
        conjuge_nome: "",
        corretor_responsavel: Afiliado || props.agenciador_id || null,
        dependentes: null,
        entrada: 1,
        excluido: false,
        imoveis_cadastrados: [props.db_id],
        imoveis_visitados: [],
        imovel_origem: props.db_id,
        visitante_id: localStorage.getItem("visitante_id"),
        origem_temporada: props.temporada ? true : false,
        possui_emprestimo: false,
        renda: null,
        registro_por_afiliado: Afiliado || null,
        proprietario: false,
        status: "Cadastrado recentemente",
        timeline: [
          {
            descrição: "Parabéns! Mais um cliente na sua lista!",
            titulo: "Cliente cadastrado!",
            data: new Date()
          },
          {
            descrição: `Cliente cadastrado no imóvel #${props.codigo}`,
            titulo: "Cadastrado em imóvel!",
            data: new Date()
          }
        ],
        troca: false,
        utilizar_financiamento: false
      };
      let uid = await EnviarContato({
        empresa_id: empresa.db_id,
        roleta: empresa.roleta_cliente,
        cliente
      });
      if (typeof uid === "string") {
        // localStorage.setItem("uid", uid);
        window.location.reload();
      }
      setVerificando(false);
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <div className="rld-single-input">
        <label
          htmlFor="Nome"
          style={{ fontSize: 0, width: "100%", marginBottom: 0 }}
        >
          Nome
          <input
            id="Nome"
            ref={props.firstInputRef}
            type="text"
            onChange={e => setnome(e.target.value)}
            value={nome}
            placeholder="Nome"
          />
        </label>
      </div>
      <div className="rld-single-input">
        <label
          htmlFor="Email"
          style={{ fontSize: 0, width: "100%", marginBottom: 0 }}
        >
          Email
          <input
            id="Email"
            type="text"
            onChange={e => setemail(e.target.value)}
            value={email}
            placeholder="Email"
          />
        </label>
      </div>
      <div className="rld-single-input">
        <label
          htmlFor="Telefone"
          style={{ fontSize: 0, width: "100%", marginBottom: 0 }}
        >
          Telefone
          <InputMask
            id="Telefone"
            name="Telefone"
            onChange={e => settelefone(e.target.value)}
            value={telefone}
            placeholder="Telefone"
            mask="(99) 99999-9999"
          />
        </label>
      </div>
      {props.temporada && (
        <>
          <div className="rld-single-input">
            <DatePicker
              singleColumn
              sideForm
              onChangeDataPicker={updateDate}
              disabledDays={reservedDates}
            />
          </div>
          <div
            className="rld-single-input"
            style={{
              position: "relative",
              zIndex: 10
            }}
          >
            <AsideSelectForm
              id="Hospedes"
              onChange={e => setHospedes(e)}
              value={hospedes}
              options={hospedesData}
              classNamePrefix="aside-form-select"
              empresa={empresa}
            />
          </div>
        </>
      )}
      {vericando ? (
        <div style={containSpinner}>
          <Spinner
            radius={30}
            color={"var(--main-color-one)"}
            stroke={3}
            visible={true}
          />
        </div>
      ) : (
        <div style={center}>
          <div onClick={onConfirm} className="btn btn-yellow">
            {props.temporada ? "Pré-reserva" : "Enviar contato!"}
          </div>
        </div>
      )}
    </>
  );
}
export default PropertyForm;
